export default __webpack_public_path__ + "static/media/5_1_logo.5f1803f5.png";